import React, { useState } from 'react';
import { getFirestore, doc, updateDoc, getDoc, deleteDoc } from "firebase/firestore";
import { getStorage, ref, deleteObject } from "firebase/storage";
import app from './firebase';

const CATEGORY_OPTIONS = [
  "pink", "green", "blue", "yellow", "white", "black",
  "red", "gold", "purple", "silver", "colorful", "pastel"
];

function WallpaperItemAdvanced({
  wallpaper,
  selected,
  onSelectChange,
  allAlbums,
  addAlbumGlobal,
  onSavedAsDone
}) {
  const [name, setName] = useState(wallpaper.name || '');
  const [tags, setTags] = useState((wallpaper.tags || []).join(', '));
  const [categories, setCategories] = useState(wallpaper.categories || []);
  const [albums, setAlbums] = useState(wallpaper.albums || []);
  const [newAlbum, setNewAlbum] = useState('');
  const [message, setMessage] = useState('');

  const db = getFirestore(app);
  const storage = getStorage(app);

  const toggleCategory = (cat) => {
    setCategories((prev) =>
      prev.includes(cat) ? prev.filter((c) => c !== cat) : [...prev, cat]
    );
  };

  const toggleAlbum = (album) => {
    setAlbums((prev) =>
      prev.includes(album) ? prev.filter((a) => a !== album) : [...prev, album]
    );
  };

  const addNewAlbum = () => {
    const trimmed = newAlbum.trim();
    if (trimmed && !albums.includes(trimmed)) {
      addAlbumGlobal(trimmed);
      setAlbums([...albums, trimmed]);
      setNewAlbum('');
    }
  };

  const handleSave = async () => {
    try {
      const docRef = doc(db, "wallpapers", wallpaper.id);
      const snapshot = await getDoc(docRef);

      let updates = {
        name: name.trim(),
        tags: tags.split(',').map((t) => t.trim()).filter((t) => t !== ''),
        categories,
        albums,
        status: "done",
      };

      // ✅ Ako nema likes ili downloads, dodaj ih kao 0
      if (!snapshot.data().hasOwnProperty("likes")) {
        updates.likes = 0;
      }
      if (!snapshot.data().hasOwnProperty("downloads")) {
        updates.downloads = 0;
      }

      await updateDoc(docRef, updates);

      setMessage('Details saved successfully!');
      setTimeout(() => setMessage(''), 3000);

      if (wallpaper.status !== 'done' && typeof onSavedAsDone === 'function') {
        onSavedAsDone();
      }

    } catch (error) {
      setMessage('Error saving details: ' + error.message);
    }
  };

  const handleDelete = async () => {
    try {
      const imageRef = ref(storage, `wallpapers/${wallpaper.name}`);
      await deleteObject(imageRef);
      await deleteDoc(doc(db, "wallpapers", wallpaper.id));
      setMessage('Wallpaper deleted successfully!');
    } catch (error) {
      setMessage('Error deleting wallpaper: ' + error.message);
    }
  };

  return (
    <div style={{
      display: 'flex',
      flexWrap: 'wrap',
      border: '1px solid #ccc',
      padding: 15,
      marginBottom: 20,
      borderRadius: 10,
      backgroundColor: '#f9f9f9'
    }}>
      <div style={{ flex: '0 0 200px', marginRight: 20 }}>
        <img
          src={wallpaper.url}
          alt={wallpaper.name}
          style={{
            width: '100%',
            height: 'auto',
            borderRadius: 8,
            objectFit: 'cover'
          }}
        />
      </div>

      <div style={{ flex: 1, minWidth: 250 }}>
        <div>
          <label><strong>Name:</strong><br />
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              style={{ width: '100%', marginBottom: 8 }}
            />
          </label>
        </div>

        <div>
          <label><strong>Tags (comma separated):</strong><br />
            <input
              type="text"
              value={tags}
              onChange={(e) => setTags(e.target.value)}
              style={{ width: '100%', marginBottom: 8 }}
            />
          </label>
        </div>

        <div>
          <strong>Categories:</strong><br />
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
            {CATEGORY_OPTIONS.map((cat) => (
              <label key={cat}>
                <input
                  type="checkbox"
                  checked={categories.includes(cat)}
                  onChange={() => toggleCategory(cat)}
                /> {cat}
              </label>
            ))}
          </div>
        </div>

        <div style={{ marginTop: 10 }}>
          <strong>Albums:</strong><br />
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
            {allAlbums.map((album) => (
              <label key={album}>
                <input
                  type="checkbox"
                  checked={albums.includes(album)}
                  onChange={() => toggleAlbum(album)}
                /> {album}
              </label>
            ))}
          </div>

          <div style={{ marginTop: 5 }}>
            <input
              type="text"
              placeholder="Add new album"
              value={newAlbum}
              onChange={(e) => setNewAlbum(e.target.value)}
              style={{ width: '60%', marginRight: 8 }}
            />
            <button onClick={addNewAlbum}>Add</button>
          </div>
        </div>

        <div style={{ marginTop: 15 }}>
          <button
            onClick={handleSave}
            disabled={albums.length === 0}
            style={{
              padding: '6px 12px',
              marginRight: 10,
              backgroundColor: '#4caf50',
              color: 'white',
              border: 'none',
              borderRadius: 4
            }}
          >
            Save
          </button>
          <button
            onClick={handleDelete}
            style={{
              padding: '6px 12px',
              backgroundColor: '#f44336',
              color: 'white',
              border: 'none',
              borderRadius: 4
            }}
          >
            Delete
          </button>
        </div>

        {message && <p style={{ marginTop: 10 }}>{message}</p>}
      </div>
    </div>
  );
}

export default WallpaperItemAdvanced;
